// Imports
// ------
import React from 'react';
import styled, { css } from 'styled-components';
import { P } from '@reuse';
import { breakup } from '@break';
import Icon from '@icons/icons';
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { themeStyles } from '@theme/theme';

// Styles
// ------
const sharedStyles = css`
    position: relative;
    display: inline-block;
    vertical-align: middle;
`;

const Jacket = styled(AniLink)`
    position: relative;

    &:hover {
        p {
            color: white;
        }

        svg {
            fill: white;
            stroke: white;
            transform: translateX(12%);
            opacity: 0;
        }
    }

    i {
        ${sharedStyles}
        transform: translateY(-0.1rem);
    }

    i, svg {
        ${props => props.theme.sizer('1.8rem')}

        ${breakup.large `
            ${props => props.theme.sizer('2.4rem')}
        `}
    }

    svg {
        ${props => props.theme.animate('.25s','ease-in-out')}
        fill: ${props => props.theme.bc5};
        stroke: ${props => props.theme.bc5};
        stroke-width: 1px;
    }
`;

const Text = styled(P)`
    ${sharedStyles}
    ${props => props.theme.animate('.25s','ease-in-out')}
    font-weight: bold;
    color: ${props => props.theme.bc5};
    margin-right: 1.2rem;

    ${breakup.large`
        margin-right: 2.4rem;
    `}
`;


// Component
// ------
const Button = ({ to, children, className }) => (
	<Jacket cover direction="right" bg={themeStyles.bc3} to={to} className={className}>
        <Text>{children}</Text>
        <Icon i="arrow-right" />
    </Jacket>
);

export default Button;